import CS1 from "../../images/personnel/IMG_2447(1) (1)-min.jpg";
import CS2 from "../../images/personnel/IMG_2437(2) (1)-min.jpg";
import CS8 from "../../images/personnel/last.jpg";
import CS10 from "../../images/personnel/Mahmunibnebashar.png";
import AM from "../../images/personnel/AM.jpg";
import AlaminImg from "../../images/personnel/alamin.png"
import LitonImg from "../../images/personnel/nurulislamliton.png";
import MahmudHasan from "../../images/personnel/mahmudhasan.jpeg"
import MoinHasan from "../../images/personnel/moinrassel.png"
import Ashraful from "../../images/personnel/Ashraf2.png"
export const corporateStaff = [
  {
    id: "anwar",
    img: CS1,
    name: "Anwar Hossain Dipu",
    title: "GM-HR-Admin",
    desc: "Compliance & Commercial",
  },
  {
    id: "fakhrul",
    img: CS2,
    name: "Md. Fakhrul Islam",
    title: "Adviser",
    desc: "Commercial, Banking, Finance & Training",
  },
  {
    id: "alamin",
    img: AlaminImg,
    name: "Al-Amin",
    title: "Manager",
    desc: "Merchandising",
  },
    {
    id: "moin",
    img: MoinHasan,
    name: "Moin Rassel",
    title: "Business Coordinator",
    desc: "",
  },
  {
    id: "abdullah",
    img: AM,
    name: "Muhammad Abdullah",
    title: "Asstt. Manager (Commercial)",
    desc: "",
  },
  {
    id: "liton",
    img: LitonImg,
    name: "Md. Nurul Islam (Liton)",
    title: "Commercial In Charge (Import)",
    desc: "Department of Commercial",
  },
  {
    id: "ashraful",
    img: Ashraful,
    name: "Ashraful Islam",
    title: "Commercial In Charge (Custom bond and Incentives)",
    desc: "",
  },
  {
    id: "bashar",
    img: CS10,
    name: "Mahmud Ibne Bashar",
    title: "Accounts In Charge",
    desc: "Accounts & Finance",
  },
  {
    id: "ripon",
    img: CS8,
    name: "Md. Ripon Hasan",
    title: "AGM",
    desc: "Industrial Engineering",
  },
  {
    id: "mahmud_it",
    img: MahmudHasan,
    name: "Mahmud Hasan",
    title: "IT incharge",
    desc: "",
  },
];

export default corporateStaff;
